import { memo, ReactNode } from 'react';

import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import { IconColor } from '@atlaskit/tokens/css-type-schema';

import { WarningCardHeader, WarningCardWrapper } from './styled';

export interface Props {
  title: string;
  color: string;
  children?: ReactNode;
}

const SettingsButton = ({ title, color, children }: Props) => {
  return (
    <WarningCardWrapper>
      <WarningCardHeader>
        <StatusWarningIcon label="Warning" color={color as IconColor} />
        <h5>{title}</h5>
      </WarningCardHeader>
      {children}
    </WarningCardWrapper>
  );
};

// eslint-disable-next-line import/no-default-export
export default memo(SettingsButton);
